import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { Button } from 'antd';
import { useRouter } from 'next/router';

const VirtualHairstyleTryOnContent = ({ style }: { style?: React.CSSProperties }) => {
  const { t } = useTranslation('common');
  const router = useRouter();

  const onDashboardClick = () => {
    router.push(`/`);
  };

  return (
    <div style={style} onClick={onDashboardClick}>
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <p className={styles.title}>{t('Virtual Hairstyle Try-On')}</p>
          <p className={styles.desc}>{t('Get ultra-realistic hairstyle try-on photos in seconds. No salon visits')}</p>
        </div>

        <div className={styles.btnContainer}>
          <Button type="primary" className={styles.signUpBtn}>
            {t('Try-On Now')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VirtualHairstyleTryOnContent;
